<div
  class="[ relative flex gap-s items-center justify-center ][ row-h-s p-is-l p-ie-m ][ corner-inherit ]"
  [class.primary-container]="selected"
  >
  @if (icon) {
    <dcr-icon
      [attr.icon]="selected ? icon + ':filled' : icon"
      class="campus-icon group-hover:on-surface group-focus-visible:on-surface"
      [class.icon-on-primary-container]="selected"
      aria-hidden="true"
    ></dcr-icon>
  }
  @if (label) {
    <label class="[ label-large flex-1 truncate ][ cursor-pointer ]" [class.on-primary-container]="active"
      >{{ label }}
    </label>
  }

  @if (badge && badge === true) {
    <campus-badge
      [value]="badge"
      [size]="badgeSize"
      class="rail-item-badge"
    ></campus-badge>
  } @else {
    @if (badge) {
      <div class="[ label-medium on-surface-variant ]">{{ badge }}</div>
    }
  }


  @if (menu) {
    <div class="relative">
      <button
        inline-icon-button
        #itemsTrigger
        click-prevent-default
        click-stop-propagation
        icon="navigation:more_vert"
      ></button>
      <campus-menu [anchor]="itemsTrigger" positioning="popover">
        @for (item of menu; track item) {
          <campus-menu-item
            (click)="item.handler(item)"
            clickStopPropagation
            clickPreventDefault
            [leadingIcon]="item.icon"
            [label]="item.label"
          ></campus-menu-item>
        }
      </campus-menu>
    </div>
  }

  <campus-state-layer
    [for]="element"
    [ngClass]="selected ? 'bg-on-primary-container' : 'bg-primary'"
  ></campus-state-layer>
  <campus-focus-ring [for]="element"></campus-focus-ring>
</div>
